// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const CheckCircleIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 23a11 11 0 010-22 11.12 11.12 0 014.47 1 1 1 0 01-.82 1.82A9.2 9.2 0 0012 3a9 9 0 000 18 9 9 0 009-9v-.92a1 1 0 112 0V12a11 11 0 01-11 11z"/><path d="M12 15a1 1 0 01-.71-.29l-3-3a1 1 0 011.42-1.41L12 12.6l9.29-9.31a1 1 0 111.42 1.42l-10 10A1 1 0 0112 15z"/></svg>'} />;

CheckCircleIcon.displayName = 'CheckCircleIcon';

export default CheckCircleIcon;
